import React, { useState, useEffect} from 'react'
import { connect } from 'react-redux';
import { getGroupCode4, getFour, postFour, putFour } from 'actions/fourEdit'
// reactstrap components
import {
    Row,
    Col, FormGroup, Input, Button, Form,
    UncontrolledTooltip,
} from "reactstrap";

// components
import FourForm from './FourForm'
import PaginationButtons from 'components/common/PaginationButtons'

const MainFours = ({
    GetFours:{group_code_4, four_list, loading},
    getGroupCode4, getFour, putFour,postFour,
    notify,currentUser
}) => {
    const [PageActiveItem, setPageActiveItem] = useState(1)

    useEffect(() => {
        getGroupCode4()
        getFour(PageActiveItem)
        if(document.getElementById('top-pagination4')) document.getElementById('top-pagination4').scrollIntoView();
    }, [PageActiveItem])

    const defValues = {analytic_number:"", analytic_name:"",extinction_1_number:"",extinction_1_name:"", extinction_2_number:"", extinction_2_name:"", type:"stale"}

    const handleSubmit = () => {
        let errorMessage = []
        if(formValues.analytic_number.length>=3){
            if(!['400','401','402','403','404','405','406'].includes(formValues.analytic_number.substring(0,3))){
                errorMessage.push('Nieprawidłowy symbol konta.')
            }
        }else{
            errorMessage.push('Zbyt krótki symbol konta.')
        }
        if(formValues.extinction_1_number.length>4) errorMessage.push('Zbyt długi numer własny 1.')
        if(formValues.extinction_2_number.length>4) errorMessage.push('Zbyt długi numer własny 2.')
        if(formValues.extinction_1_name.length>1000) errorMessage.push('Zbyt długa nazwa własna 1.')
        if(formValues.extinction_2_name.length>1000) errorMessage.push('Zbyt długa nazwa własna 2.')

        if(errorMessage.length!==0){
            notify(errorMessage.join(' '))
        }else{
            postFour(formValues)
            setFormValues(defValues)
        }
    }
   
    const [formValues,setFormValues]=useState(defValues)

    const handleFieldChange = (e) => {
        const itemID = parseInt(e.target.id.split('-')[1])
        const itemName = e.target.id.split('-')[0]
        const itemValue = e.target.value
        setFormValues((prevState) => {
            let newState = { ...prevState };
            newState[itemName] = itemValue
            return(newState)
        })
    }
    
    return (
        <>
            <div className={'form-fields-container'} style={{margin: '0 15px', alignItems: 'flex-end'}} >
                <Row className={'row-margin'} style={{alignItems: 'flex-end'}} >
                    <Col sm={4}>
                        <Row className={'text-center'} style={{color:"#595959", fontSize:"0.8571em"}} >
                            <Col sm={3}> Symbol konta </Col>
                            <Col sm={9}> Nazwa analityczna </Col>
                        </Row>
                    </Col>

                    <Col sm={8}>
                        <Row className={'row-margin text-center'} style={{alignItems: 'flex-end', color:"#595959", fontSize:"0.8571em"}} >
                            <Col sm={1}> Numer własny 1 </Col>
                            <Col sm={3}> Nazwa własna 1 </Col>
                            <Col sm={1}> Numer własny 2 </Col>
                            <Col sm={3}> Nazwa własna 2 </Col>
                            <Col sm={3}> Rodzaj kosztów </Col>
                            <Col sm={1}> Dodaj </Col>
                        </Row>
                    </Col>
                </Row>
                <Form key={"opk_idx"} id={"opk_item.id"} className='okraglaczki'>
                    <Row className={'row-margin'}>
                        <Col sm={4}>
                            <Row className={''}>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor='analytic_number-add' className='sr-only'>Symbol konta</label>
                                        <Input
                                            id={`analytic_number-add`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={formValues.analytic_number}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={9}>
                                    <FormGroup>
                                        <label htmlFor='analytic_name-add' className='sr-only'>Nazwa analityczna</label>
                                        <Input
                                            id={`analytic_name-add`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={formValues.analytic_name}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                {/* <Col sm={2}>
                                    <FormGroup>
                                        <Input
                                        value={opk_item.group_id}
                                        type="select"
                                        name="select"
                                        id={`group_id-${opk_idx}`}
                                        onChange={(e) => handleFieldChange(e)}
                                        >
                                            {group_code.map((groupCodeItem, codeIdx )=>{
                                                return(
                                                    <option key={codeIdx} value={groupCodeItem.id}>{`${groupCodeItem.group_number}`}</option>
                                                )
                                            })}
                                        </Input>
                                    </FormGroup>
                                </Col> */}
                            </Row>
                        </Col>
                        <Col sm={8}>
                            <Row className={'row-margin'}>
                                <Col sm={1}>
                                    <FormGroup>
                                        <label htmlFor='extinction_1_number-add' className='sr-only'>Numer własny 1</label>
                                        <Input
                                            id={`extinction_1_number-add`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={formValues.extinction_1_number}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor='extinction_1_name-add' className='sr-only'>Nazwa własna 1</label>
                                        <Input
                                            id={`extinction_1_name-add`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={formValues.extinction_1_name}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={1}>
                                    <FormGroup>
                                        <label htmlFor='extinction_2_number-add' className='sr-only'>Numer własny 2</label>
                                        <Input
                                            id={`extinction_2_number-add`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={formValues.extinction_2_number}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor='extinction_2_name-add' className='sr-only'>Nazwa własna 2</label>
                                        <Input
                                            id={`extinction_2_name-add`}
                                            className={'font-small'}
                                            type={'text'}
                                            value={formValues.extinction_2_name}
                                            onChange={(e) => handleFieldChange(e)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={3}>
                                    <FormGroup>
                                        <label htmlFor='type-type' className='sr-only'>Rodzaj kosztów</label>
                                        <Input
                                            value={formValues.type}
                                            type="select"
                                            name="select"
                                            id={`type-type`}
                                            onChange={(e) => handleFieldChange(e)}
                                        >
                                            <option value={"stale"}>stałe</option>
                                            <option value={"zmienne"}>zmienne</option>
                                            {/* <option value={"brak"}>brak</option> */}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col sm={1}>
                                    <Row className={'text-center'}>
                                        <Col >
                                        <Button
                                            className="btn-round btn mr-1" outline
                                            color="import"
                                            data-toggle="tooltip"
                                            id={`save`}
                                            // size="sm"
                                            style={{marginTop:"0px", width:"58px"}}
                                            type="button"
                                            onClick={e=>handleSubmit()} 
                                            disabled={currentUser && currentUser.company === null}
                                            aria-label='Dodaj konto'

                                        >
                                             <i className='nc-icon nc-simple-add'></i>
                                            {/* <i className="far fa-plus-square fa-2x"></i> */}
                                        </Button>
                                        <UncontrolledTooltip
                                            delay={0}
                                            placement="top"
                                            target={`save`}
                                        >
                                            Dodaj konto
                                        </UncontrolledTooltip>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Form>
            </div>
            <hr></hr>
            <div className={'form-fields-container'} id='top-pagination4'>
                {!loading && four_list.results? 
                    <>
                        <PaginationButtons 
                            pageNumber={four_list.count} 
                            PageActiveItem={PageActiveItem} 
                            setPageActiveItem={setPageActiveItem}
                        />
                        <FourForm four_list={four_list.results} group_code={group_code_4} dataSubmit={putFour} notify={notify}/>
                        <PaginationButtons 
                            pageNumber={four_list.count} 
                            PageActiveItem={PageActiveItem} 
                            setPageActiveItem={setPageActiveItem}
                        />
                    </>
                    : <>Pobieranie danych z serwera...</>
                }
            </div>
        </>
    )
}


const mapStateToProps = (state) => ({
  GetFours: state.GetFours,
  currentUser: state.UserReducer.currentUser

});

export default connect(mapStateToProps,{postFour,getGroupCode4, getFour, putFour})(MainFours)
